import { MessageInstance } from 'antd/es/message/interface'
import {
  FormField,
  GeckoMeasurementSystem,
  GeckoMeasurementUnit,
  RolodexEntryPutJson,
} from 'types'

export enum FeatureFormMode {
  Add,
  Edit,
}

export interface FormFieldsByUniqueID {
  uniqueID: string
  formFields: FormField[]
}

export type SimpleFormField = {
  [key: string]: string | string[] | undefined
}

export interface PermissionsCheck {
  userPermissions: ReadonlySet<string> | undefined
  permissionsChecker: (
    formField: FormField,
    userPermissions?: ReadonlySet<string> | undefined
  ) => { canEditField: boolean; canReadField: boolean }
}

export interface MeasurementApplication {
  measurementSystem: GeckoMeasurementSystem
  measurementApplication: (
    formField: FormField,
    measurementSystem: GeckoMeasurementSystem
  ) => {
    fieldValue: string | number | string[] | undefined
    fieldUnits: string
    units: GeckoMeasurementUnit | null
  }
}

export type HandleSaveToRolodexType = (
  entries: RolodexEntryPutJson[],
  messageApi: MessageInstance,
  forceRefresh: () => Promise<void>,
  formID?: string
) => void
